const DEALER_ROLE = 'dealer'
const SALES_ROLE = 'sales'
const CS_ROLE = 'cs'

const ROLES = [DEALER_ROLE, SALES_ROLE, CS_ROLE]

module.exports = { DEALER_ROLE, SALES_ROLE, CS_ROLE, ROLES }
